import React, { useCallback, useState } from "react";

import {
  SizeAndFitSheet,
  type SizeAndFitButtonProps,
} from "~/templates/product/SizeAndFitSheet";

import { IconChevron, Image } from "@bared/ui";

export function FitkitButton({
  gender,
  isFitKitIncluded,
}: SizeAndFitButtonProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSheetToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [isOpen]);

  return (
    <>
      <div
        className="flex w-full cursor-pointer items-stretch justify-between rounded-[8px] border border-primary-100 bg-primary-100"
        onClick={handleSheetToggle}
      >
        <div className="flex items-stretch gap-mini">
          <div className="flex h-full max-w-[80px] items-center rounded-l-[8px] bg-primary-150">
            <Image
              source="shopify"
              data={{
                url: "https://cdn.shopify.com/s/files/1/0322/6841/9208/files/WebsiteStatic-Accessory-FitKit-250612.png?v=1749703343",
                height: 1080,
                width: 990,
              }}
              className="object-contain"
            />
          </div>

          <div className="flex flex-col justify-center py-micro">
            <p className="text-hint font-medium">
              Includes customisable Fit Kit
            </p>
            <p className="text-[12px]">
              Wide, narrow or in between? Tailor the fit to suit you.
            </p>
          </div>
        </div>

        <div className="inline-flex px-mini py-midi">
          <IconChevron className="w-[10px] rotate-[270deg] text-primary" />
        </div>
      </div>

      <SizeAndFitSheet
        activeTab="customisableFit"
        isOpen={isOpen}
        handleSheetToggle={handleSheetToggle}
        gender={gender}
        isFitKitIncluded={isFitKitIncluded}
      />
    </>
  );
}
